<div *ngIf="errorMessage == null && this.model.LeaseInStatus == true" id="cancel-ntv" class="form-container">
  <div class="row">
    <div class="col-md-12 text-center">
      <p>Unfortunately, we are unable to cancel your notice at this time. Please contact us at 855.676.1680 for more information.      
        </p>
    </div>
  </div>
</div>
<div *ngIf="errorMessage == null && this.model.LeaseInStatus != true && this.model.NTVCanceled == true" id="cancel-ntv" class="form-container">
  <div class="row">
    <div class="col-md-12 text-center">
      <p>NTV is already canceled. If you need further assistance, please call 855.676.1680</p>
    </div>
  </div>
</div>
<div *ngIf="errorMessage == null && this.model.NTVCanceled == false && this.model.LeaseInStatus != true" id="cancel-ntv" class="form-container">
  <div class="row">
    <div class="col-md-12 text-center">
      <p>To confirm your cancellation of your notice to vacate, and continue to lease
         <br>{{model.Address}}, <br>please click the button below.
        </p>
    </div>
  </div>
  <br><br>
  <form id="cancelForm" #cancelForm = "ngForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 text-center">
        <button id="confirmCancel" type="submit" class="btn st-btn-next" [disabled]="!cancelForm.form.valid">CONFIRM CANCELLATION</button>
      </div>
    </div>
  </form>
</div>
<div *ngIf="this.successfullyCanceledNtv && errorMessage == null && this.model.LeaseInStatus != true" class="row">
  <div class="row">
    <div class="col-md-12 text-center">
      <br><br><br><br>
      <h4>Cancellation Approved</h4><br><br>
      <p>We look forward to continuing to serve you as one of our valued residents.</p>
    </div>
  </div>     
</div>
